import React, { FC, memo } from "react";
import { IUser } from "@utils";
import { CollapsibleList } from "../../collapsibleList";
import { User } from "../../user";
import { LoadableWrapper } from "../../loader";
import "../../../styles/components/employees.scss";

interface IEmployeesProps {
  users: IUser[];
  onChooseEmployee: (id: number) => void;
  selectEmployeeId: number | null;
  isLoading: boolean;
}

export const Employees: FC<IEmployeesProps> = memo(
  ({ users, isLoading, selectEmployeeId, onChooseEmployee }) => (
    <LoadableWrapper loading={isLoading}>
      <div className="block employees">
        <CollapsibleList<IUser>
          title="Сотрудники"
          listItems={users}
          placeholder="Сотрудников нет"
          getSearchOption={(option) => option.fullName}
          onEnterPress={(option) => onChooseEmployee(option.id)}
          renderOption={(member) => (
            <User
              key={member.id}
              member={member}
              isSelected={member.id === selectEmployeeId}
              onClickMember={onChooseEmployee}
              isHeader
            />
          )}
        />
      </div>
    </LoadableWrapper>
  )
);
